module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/lead/lead.component.css
// module id = ./src/app/Pages/lead/lead.component.css
// module chunks = main